module.exports = __webpack_public_path__ + "static/media/socialwall-background.d1209c67.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/screenshots/socialwall-background.jpg
 ** module id = 434
 ** module chunks = 0
 **/